/* v28 — LACO PDP runtime. Vanilla. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root._lcInit) return;
    root._lcInit = true;

    // ── Gallery ──
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-lc-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lc-thumb]'));
    function activateIndex(idx) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    }
    function activateMediaId(mediaId) {
      if (!mediaId) return false;
      var found = false;
      slides.forEach(function (s, i) {
        var match = s.getAttribute('data-lc-media-id') === String(mediaId);
        if (match) { activateIndex(i); found = true; }
      });
      return found;
    }
    // v46 BLOK 1 — fallback when mediaId is null OR not in slide DOM
    // Strip query string + width tokens from CDN URLs so legacy variant.image
    // src can match an OS2.0 product.media src (Shopify CDN re-encodes widths).
    function urlBase(u) {
      if (!u) return '';
      try {
        var x = new URL(u, window.location.origin);
        // Drop query, drop width token in pathname like "_1200x"
        return (x.origin + x.pathname).replace(/_\d+x\d*(\.[a-z0-9]+)$/i, '$1');
      } catch (e) {
        return String(u).split('?')[0].replace(/_\d+x\d*(\.[a-z0-9]+)$/i, '$1');
      }
    }
    function activateBySrc(imageSrc) {
      if (!imageSrc) return false;
      var target = urlBase(imageSrc);
      var found = false;
      slides.forEach(function (s, i) {
        var img = s.querySelector('img');
        if (!img) return;
        if (urlBase(img.currentSrc || img.src) === target) {
          activateIndex(i); found = true;
        }
      });
      return found;
    }
    function activateForVariant(variantEntry) {
      // variantEntry can be either a media-id number (legacy v45 format) or { mediaId, imageSrc } object (v46)
      if (!variantEntry) return false;
      var mediaId = null, imageSrc = null;
      if (typeof variantEntry === 'object') {
        mediaId = variantEntry.mediaId;
        imageSrc = variantEntry.imageSrc;
      } else {
        mediaId = variantEntry;
      }
      if (mediaId && activateMediaId(mediaId)) return true;
      if (imageSrc && activateBySrc(imageSrc)) return true;
      // Last resort: mutate the currently-active slide's <img> src directly.
      if (imageSrc) {
        var active = null;
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('is-active')) { active = slides[i]; break; }
        }
        if (active) {
          var heroImg = active.querySelector('img');
          if (heroImg) { heroImg.src = imageSrc; heroImg.srcset = ''; return true; }
        }
      }
      return false;
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { activateIndex(i); });
    });

    // v32 B4 — left/right arrow navigation
    function currentIndex() {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) return i;
      }
      return 0;
    }
    var prevBtn = root.querySelector('[data-lc-nav="prev"]');
    var nextBtn = root.querySelector('[data-lc-nav="next"]');
    if (prevBtn) prevBtn.addEventListener('click', function () {
      var idx = (currentIndex() - 1 + slides.length) % slides.length;
      activateIndex(idx);
    });
    if (nextBtn) nextBtn.addEventListener('click', function () {
      var idx = (currentIndex() + 1) % slides.length;
      activateIndex(idx);
    });

    // ── Accordion ──
    root.querySelectorAll('[data-lc-acc]').forEach(function (acc) {
      var btn = acc.querySelector('[data-lc-acc-toggle]');
      var panel = acc.querySelector('.lc-pdp__acc-a');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = acc.hasAttribute('data-lc-open');
        if (open) { acc.removeAttribute('data-lc-open'); btn.setAttribute('aria-expanded', 'false'); panel.setAttribute('hidden', ''); }
        else { acc.setAttribute('data-lc-open', ''); btn.setAttribute('aria-expanded', 'true'); panel.removeAttribute('hidden'); }
      });
    });

    // ── Variant switching ──
    var variants = [];
    var variantMedia = {};
    var vScript = root.querySelector('[data-lc-variants]');
    if (vScript) { try { variants = JSON.parse(vScript.textContent); } catch (e) {} }
    var vmScript = document.querySelector('[data-lc-variant-media]');
    if (vmScript) { try { variantMedia = JSON.parse(vmScript.textContent); } catch (e) {} }

    var form = root.querySelector('[data-lc-form]');
    var hiddenId = root.querySelector('[data-lc-variant-id]');
    var atc = root.querySelector('[data-lc-atc]');
    var atcLabel = root.querySelector('[data-lc-atc-label]');
    var priceEl = root.querySelector('[data-lc-price]');
    var stickyPrice = root.querySelector('[data-lc-sticky-price]');

    function formatMoney(cents) {
      var amt = (cents / 100).toFixed(2);
      return '$' + amt.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function selectedValues() {
      var inputs = root.querySelectorAll('[data-lc-opt]:checked');
      var vals = [];
      Array.prototype.forEach.call(inputs, function (i) {
        vals[parseInt(i.dataset.lcOptPosition, 10) - 1] = i.dataset.lcOptValue;
      });
      return vals;
    }
    function findVariant(vals) {
      return variants.find(function (v) {
        var arr = [v.option1, v.option2, v.option3];
        for (var i = 0; i < vals.length; i++) {
          if (vals[i] && arr[i] !== vals[i]) return false;
        }
        return true;
      });
    }
    function updateForVariant(v) {
      if (!v) {
        if (atc) atc.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      if (hiddenId) hiddenId.value = v.id;
      var price = formatMoney(v.price);
      if (priceEl) priceEl.textContent = price;
      if (stickyPrice) stickyPrice.textContent = price;
      if (atc) {
        atc.disabled = !v.available;
        if (atcLabel) {
          if (v.available) atcLabel.innerHTML = 'Add to cart — <span data-lc-atc-price>' + price + '</span>';
          else atcLabel.textContent = 'Sold out';
        }
      }
      // v46 BLOK 1 — Authoritative gallery swap with 3-layer fallback (mediaId → src → direct hero mutate)
      activateForVariant(variantMedia[v.id]);
      // v58 — keep the mobile edition preview image in sync with the gallery hero
      if (root.__lcSyncEditionPreview) root.__lcSyncEditionPreview();
      // Update selected-value labels
      root.querySelectorAll('[data-lc-opt-selected]').forEach(function (lbl) {
        var pos = parseInt(lbl.dataset.lcOptSelected, 10);
        var val = [v.option1, v.option2, v.option3][pos - 1];
        if (val) lbl.textContent = val;
      });
      // URL update
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
    function refresh() {
      var vals = selectedValues();
      var v = findVariant(vals);
      root.querySelectorAll('.lc-pdp__opt-item').forEach(function (lbl) {
        var input = lbl.querySelector('[data-lc-opt]');
        if (input) lbl.classList.toggle('is-selected', input.checked);
      });
      updateForVariant(v);
    }
    root.querySelectorAll('[data-lc-opt]').forEach(function (i) {
      i.addEventListener('change', refresh);
    });
    refresh();

    // ── Sticky ATC ──
    var sticky = root.querySelector('[data-lc-sticky]');
    var stickyCta = root.querySelector('[data-lc-sticky-cta]');
    if (sticky && atc) {
      // GORUNMUYOR ile GECILDI ayni sey DEGIL (Mert 2026-08-11: "sticky cta heroda
      // acilmasin, urune bakarken de acilmasin, urunden asagi inince acilsin").
      //
      // Eski kural `intersectionRatio === 0` idi: ATC gorunmedigi HER AN bar aciliyordu,
      // sayfanin tepesinde ATC daha ASAGIDA oldugu icin de "gorunmuyor" sayilip bar
      // hero'da aciliyordu.
      //
      // IntersectionObserver bu isi TEK BASINA yapamaz ve sebebi olculdu: gozlemci yalniz
      // ORAN DEGISINCE atesler. "Asagida oldugu icin gorunmuyor" ile "yukarida kaldigi icin
      // gorunmuyor" arasinda oran hep 0'dir — yani gecisin kendisi hic haber verilmez, ve
      // callback'e gelen boundingClientRect o ESKI andan kalir. Bu yuzden konum her
      // kaydirmada CANLI okunuyor.
      var stickyGuncelle = function () {
        var r = atc.getBoundingClientRect();
        var gecildi = r.bottom <= 0;   // ATC viewport'un USTUNDE kaldi = urunu gectik
        sticky.classList.toggle('is-visible', gecildi);
        sticky.setAttribute('aria-hidden', gecildi ? 'false' : 'true');
      };
      var bekliyor = false;
      var tetikle = function () {
        if (bekliyor) return;
        bekliyor = true;
        requestAnimationFrame(function () { bekliyor = false; stickyGuncelle(); });
      };
      window.addEventListener('scroll', tetikle, { passive: true });
      window.addEventListener('resize', tetikle);
      stickyGuncelle();
    }
    if (stickyCta && form) {
      stickyCta.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
    }
    // v64 — "Back" CTA on the sticky ATC → browser back, with a same-origin
    // referrer / history fallback chain (never a dead end).
    var stickyBack = root.querySelector('[data-lc-sticky-back]');
    if (stickyBack) {
      stickyBack.addEventListener('click', function () {
        if (window.history.length > 1) { window.history.back(); return; }
        try {
          if (document.referrer) {
            var ref = new URL(document.referrer);
            if (ref.origin === window.location.origin) { window.location.href = ref.href; return; }
          }
        } catch (e) {}
        window.location.href = '/collections';
      });
    }

    // ── Size guide modal ──
    var sg = root.querySelector('[data-lc-size-guide]');
    if (sg) {
      function openSg() { sg.classList.add('is-open'); sg.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
      function closeSg() { sg.classList.remove('is-open'); sg.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
      root.querySelectorAll('[data-lc-size-guide-open]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); openSg(); });
      });
      root.querySelectorAll('[data-lc-size-guide-close]').forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); closeSg(); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && sg.classList.contains('is-open')) closeSg();
      });
    }

    // ── Mobile popover tap (persona + artist) ──
    root.querySelectorAll('[data-lc-popover]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) return;
        e.stopPropagation();
        el.classList.toggle('is-open');
      });
    });
    document.addEventListener('click', function (e) {
      root.querySelectorAll('[data-lc-popover].is-open').forEach(function (el) {
        if (!el.contains(e.target)) el.classList.remove('is-open');
      });
    });
  }

  // v33 İŞ1 — Description premium parser
  function parseDescription(root) {
    var raw = root.querySelector('[data-lc-desc-raw]');
    var pretty = root.querySelector('[data-lc-desc-pretty]');
    if (!raw || !pretty) return;
    var html = raw.innerHTML;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var intro = [];
    var specs = [];
    var footer = [];
    var LABELS = ['Material','Frame finishes','Frame finish','Frame Finishes','Frame','Protection','Sizes','Size','Hanging','Care'];

    function matchLabel(text) {
      for (var i = 0; i < LABELS.length; i++) {
        var lbl = LABELS[i];
        var re = new RegExp('^[•·\\s]*' + lbl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*[:—]\\s*', 'i');
        if (re.test(text)) return { label: lbl, re: re };
      }
      return null;
    }

    function processLine(node) {
      var text = (node.textContent || '').trim();
      if (!text) return;

      // Footer (Printed and shipped / From the LACO)
      if (/^(Printed and shipped|From the LACO|From the\s)/i.test(text)) {
        text.split(/\.\s+|<br\/?>/).filter(Boolean).forEach(function (line) {
          line = line.replace(/^\s+|\s+$/g,'');
          if (line) footer.push(line + (line.match(/[.,!?]$/) ? '' : '.'));
        });
        return;
      }

      // Strategy: get the FULL text of this element, then try matching any known LABEL
      // at the start. Strong tag is just a hint — the canonical match is by text prefix.
      var fullText = text;
      var strong = node.querySelector('strong');
      var candidateLabel = null;

      if (strong) {
        // Extract label from strong: text before first colon
        var strongText = strong.textContent.trim();
        var colon = strongText.indexOf(':');
        if (colon > 0) {
          candidateLabel = strongText.slice(0, colon).replace(/^[•·\s]+/, '').trim();
        } else {
          candidateLabel = strongText.replace(/^[•·\s]+/, '').trim();
        }
      }

      // If we have a candidate, try to match it against LABELS
      var matchedLabel = null;
      if (candidateLabel) {
        for (var i = 0; i < LABELS.length; i++) {
          if (LABELS[i].toLowerCase() === candidateLabel.toLowerCase()) {
            matchedLabel = LABELS[i];
            break;
          }
        }
      }

      // Also try plain-text label match (no strong)
      if (!matchedLabel) {
        var m = matchLabel(fullText);
        if (m) { matchedLabel = m.label; }
      }

      if (matchedLabel) {
        // Strip "[bullet]Label[:—] " prefix from full text → value
        var stripRe = new RegExp(
          '^[•·\\s]*' + matchedLabel.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\s*[:—]\\s*',
          'i'
        );
        var value = fullText.replace(stripRe, '').trim();
        // Remove trailing period if value is just "." or similar
        if (value && value !== '.') {
          specs.push({ label: matchedLabel.toUpperCase(), value: value });
        }
        return;
      }

      // No label — intro only if no specs yet, and not a colorways line
      if (specs.length === 0) {
        intro.push(fullText);
      }
    }

    // v33 fix — flat traversal of every <p> and <li> across the description tree
    var blocks = tmp.querySelectorAll('p, li');
    Array.prototype.forEach.call(blocks, processLine);

    var html_out = '';
    if (intro.length) {
      html_out += '<p class="lc-pdp__desc-intro">' + intro.join(' ') + '</p>';
    }
    if (specs.length) {
      html_out += '<dl class="lc-pdp__desc-spec">';
      specs.forEach(function (s) {
        html_out += '<div class="lc-pdp__desc-spec-row">';
        if (s.label) html_out += '<dt>' + s.label + '</dt>';
        html_out += '<dd>' + s.value + '</dd>';
        html_out += '</div>';
      });
      html_out += '</dl>';
    }
    if (footer.length) {
      html_out += '<p class="lc-pdp__desc-footer">' + footer.join(' · ') + '</p>';
    }
    pretty.innerHTML = html_out;
  }

  // v35 F6-BUTON — Format switch popup with REAL variant BUTTONS (color/frame), click → popup hero swap
  function initFormatPopup(root) {
    var fpop = root.querySelector('[data-lc-fpop]');
    var sib_script = root.querySelector('[data-lc-sibling-urls]');
    if (!fpop || !sib_script) return;
    var siblings = {};
    try { siblings = JSON.parse(sib_script.textContent); } catch (e) {}

    // v61 — use the shared complete map (46 colours + 8 frames).
    var COLOR_HEX = LC_EDITION_HEX;

    function open(key) {
      var data = siblings[key];
      if (!data) return;
      var fmtName = key === 'canvas' ? 'Canvas Edition'
                  : key === 'metal'  ? 'Premium Metal Framed'
                  : key === 'wood'   ? 'Premium Wooden Framed'
                  : key === 'framed' ? 'Framed Canvas'
                  : 'Edition';
      var bodyText = key === 'canvas'
        ? '300–350gsm cotton-poly blend on FSC-certified pine stretcher. Slim 2cm profile, ready to hang.'
        : key === 'metal'
          ? '200gsm matte paper, shatterproof plexiglass, black aluminum frame. Ships with frame.'
          : key === 'wood'
            ? '250gsm archival matte paper, oak or ash hardwood, four finishes.'
            : '300–350gsm cotton-poly canvas in a slim FSC-certified wood floater frame — Black or Dark Wood.';
      fpop.querySelector('[data-lc-fpop-eyebrow]').textContent = 'In this format';
      fpop.querySelector('[data-lc-fpop-title]').textContent = data.title || fmtName;
      fpop.querySelector('[data-lc-fpop-body]').textContent = bodyText;
      var imgWrap = fpop.querySelector('[data-lc-fpop-img]');

      // v36 BLOK 3 — Two-layer <img> swap to eliminate flash: keep previous bitmap visible until new one decodes, then cross-flip.
      // Layer A and B are stacked; one is current (opacity 1), the other is preload buffer (opacity 0). Swap = decode B, then flip opacity in one tick.
      var imgA = imgWrap.querySelector('[data-lc-fpop-himg="a"]');
      var imgB = imgWrap.querySelector('[data-lc-fpop-himg="b"]');
      if (!imgA || !imgB) {
        imgWrap.innerHTML = '';
        imgA = document.createElement('img');
        imgA.setAttribute('data-lc-fpop-himg', 'a');
        imgA.alt = '';
        imgA.decoding = 'async';
        imgA.className = 'lc-pdp__fpop-himg lc-pdp__fpop-himg--active';
        imgB = document.createElement('img');
        imgB.setAttribute('data-lc-fpop-himg', 'b');
        imgB.alt = '';
        imgB.decoding = 'async';
        imgB.className = 'lc-pdp__fpop-himg';
        imgWrap.appendChild(imgA);
        imgWrap.appendChild(imgB);
      }
      if (data.image) {
        imgA.src = data.image;
        imgA.classList.add('lc-pdp__fpop-himg--active');
        imgB.classList.remove('lc-pdp__fpop-himg--active');
      }

      var cta = fpop.querySelector('[data-lc-fpop-cta]');
      cta.href = data.url;

      // v35 F6-BUTON — render REAL variant buttons (Color swatches + Frame Finish pills + Size pills)
      var strip = fpop.querySelector('[data-lc-fpop-strip]');
      if (strip) {
        strip.innerHTML = '';
        var options = data.options || [];
        var variants = data.variants || [];
        if (options.length === 0 || variants.length === 0) {
          // No variants — keep empty
        } else {
          var selected = {};
          options.forEach(function (opt) {
            // Default selected = featured variant's value for this opt (or first available)
            var firstAvail = variants.find(function (v) { return v.available; }) || variants[0];
            selected[opt.position] = firstAvail['option' + opt.position];
          });

          function findMatchedVariant() {
            return variants.find(function (v) {
              for (var i = 0; i < options.length; i++) {
                var pos = options[i].position;
                if (selected[pos] && v['option' + pos] !== selected[pos]) return false;
              }
              return true;
            });
          }
          // v36 BLOK 3 — Preload all variant images so swap is instant; cache by src
          var preloadCache = {};
          variants.forEach(function (v) {
            if (v.image && !preloadCache[v.image]) {
              var p = new Image();
              p.decoding = 'async';
              p.src = v.image;
              preloadCache[v.image] = p;
            }
          });
          function renderImageForSelection() {
            var v = findMatchedVariant();
            var src = (v && v.image) ? v.image : data.image;
            if (!src) return;
            // Determine which layer is currently active and which is buffer
            var active = imgA.classList.contains('lc-pdp__fpop-himg--active') ? imgA : imgB;
            var buffer = (active === imgA) ? imgB : imgA;
            if (active.src === src) return;
            // Load new src into buffer, then once decoded flip active class — previous bitmap stays visible till buffer is ready
            buffer.src = src;
            function doFlip() {
              buffer.classList.add('lc-pdp__fpop-himg--active');
              active.classList.remove('lc-pdp__fpop-himg--active');
            }
            if (buffer.complete && buffer.naturalWidth > 0) {
              doFlip();
            } else if (buffer.decode) {
              buffer.decode().then(doFlip).catch(doFlip);
            } else {
              buffer.onload = doFlip;
            }
          }

          options.forEach(function (opt) {
            var nm = (opt.name || '').toLowerCase().trim();
            // Hide single-value Color (consistent with main PDP) and Size (popup is format preview, not config)
            if ((nm === 'color' || nm === 'colour' || nm === 'colorway' || nm === 'renk') && opt.values.length < 2) return;
            if (nm === 'size' || nm === 'sizes' || nm === 'boyut' || nm === 'ölçü' || nm === 'olcu') return;

            var isColor = (nm === 'color' || nm === 'colour' || nm === 'colorway' || nm === 'renk');
            var groupCls = isColor ? 'lc-pdp__fpop-opt lc-pdp__fpop-opt--color' : 'lc-pdp__fpop-opt lc-pdp__fpop-opt--pill';
            var group = document.createElement('div');
            group.className = groupCls;
            var lbl = document.createElement('p');
            lbl.className = 'lc-pdp__fpop-opt-label';
            lbl.textContent = opt.name;
            group.appendChild(lbl);
            var list = document.createElement('div');
            list.className = 'lc-pdp__fpop-opt-list';
            opt.values.forEach(function (val) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'lc-pdp__fpop-opt-btn' + (selected[opt.position] === val ? ' is-selected' : '');
              btn.setAttribute('data-lc-fpop-opt-pos', opt.position);
              btn.setAttribute('data-lc-fpop-opt-val', val);
              if (isColor) {
                var hex = COLOR_HEX[val.toLowerCase().trim()] || '#ccc';
                btn.innerHTML = '<span class="lc-pdp__fpop-opt-swatch" style="background:' + hex + '" title="' + val + '"></span>';
                btn.setAttribute('aria-label', val);
              } else {
                btn.textContent = val;
              }
              btn.addEventListener('click', function () {
                selected[opt.position] = val;
                group.querySelectorAll('[data-lc-fpop-opt-pos="' + opt.position + '"]').forEach(function (x) {
                  x.classList.toggle('is-selected', x === btn);
                });
                renderImageForSelection();
                // Update CTA to deep-link to selected variant
                var v = findMatchedVariant();
                if (v) {
                  try {
                    var u = new URL(data.url, window.location.origin);
                    u.searchParams.set('variant', v.id);
                    cta.href = u.pathname + u.search;
                  } catch (err) {}
                }
              });
              list.appendChild(btn);
            });
            group.appendChild(list);
            strip.appendChild(group);
          });
        }
      }

      fpop.classList.add('is-open');
      fpop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      fpop.classList.remove('is-open');
      fpop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    root.querySelectorAll('[data-lc-fpop-open]').forEach(function (b) {
      b.addEventListener('click', function () { open(b.dataset.lcFpopOpen); });
    });
    fpop.querySelectorAll('[data-lc-fpop-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && fpop.classList.contains('is-open')) close();
    });
  }

  // v47 BLOK 5 — initRoomCart silindi (Room placeholder + "See it in your space" CTA blok kaldırıldı).
  function initRoomCart() {}

  // v35 F3-GERÇEKTEN — Real pill classes found: .scm (Collections), .sccu (Contact).
  // CSS already kills them at all viewports; JS is belt-and-suspenders for dynamic insertion + computed-style override.
  function hidePdpPills() {
    if (!document.body.classList.contains('template-product') && !document.querySelector('[data-lc-pdp]')) return;
    var sels = [
      '.scm', '.sccu', '.scm__modal', '.scm__cta',
      '[data-scm]', '[data-sccu]',
      '[data-floating-pill]', '.lc-floating-pill', '.lc-contact-pill', '.lc-collections-pill',
      '.laco-floating-dock', '.floating-pills', '.fab-pills', '.bottom-pills',
      '.global-pill', '.global-pills',
      '.fab-collections', '.fab-contact', '.pill-collections', '.pill-contact',
      '.contact-pill', '.collections-pill',
      '.floating-contact', '.floating-collections', '.sticky-pills', '.sticky-pill'
    ];
    document.querySelectorAll(sels.join(',')).forEach(function (el) {
      var isInChrome = el.closest('header,nav,footer,.header,.footer,.navigation,.menu,main,.lc-pdp');
      // Always kill — these classes are the floating pill itself and should never appear on PDP regardless of position.
      if (!isInChrome) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
      }
    });
  }
  // v35 F3 — MutationObserver: pills can be re-injected by other scripts (cart drawer, theme settings)
  function watchPdpPills() {
    if (!document.body.classList.contains('template-product')) return;
    if (!('MutationObserver' in window)) return;
    var rafScheduled = false;
    var mo = new MutationObserver(function () {
      if (rafScheduled) return;
      rafScheduled = true;
      window.requestAnimationFrame(function () {
        rafScheduled = false;
        hidePdpPills();
      });
    });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
  }

  // v60 — Edition preview + format selector unified. The "Notes on this edition"
  // block carries an interactive preview: a product image + a swatch row that
  // rebuilds per format. Pick Canvas/Metal/Wooden → image + swatches follow that
  // format's product (colorway on canvas, frame finish white/dark on wooden).
  // Sibling JSON [data-lc-sibling-urls] carries all three formats incl. the
  // current one, each with options + variants (+ per-variant images).
  // v61 — Complete colorway + frame-finish hex map. Mirrors snippets/lc-color-map.liquid
  // exactly (46 colours + 8 frames). No catalog value falls through to grey.
  var LC_EDITION_HEX = {
    'crimson':'#8B1A2B','cobalt':'#1B3A8C','aged cobalt':'#3B5A87','deep navy':'#1E2F52',
    'emerald':'#00845A','forest':'#2F5A3F','forest green':'#2F5A3F','teal':'#1A7A6D',
    'faded teal':'#7FA199','sky blue':'#B5C9D6','dusty blue':'#8DA8C0','charcoal':'#3A3A3A',
    'warm charcoal':'#4A3F38','noir':'#141414','cream':'#EFE7D8','gold':'#D4A858',
    'warm gold':'#D4A858','ochre':'#D4943A','warm amber':'#C99056','copper':'#B5703C',
    'muted caramel':'#C2925E','warm sand':'#D4B58E','sunbaked yellow':'#E8C552','neon':'#C6E840',
    'orange':'#D4742C','burnt orange':'#C85A2C','burnt':'#C85A2C','terracotta':'#B07458',
    'sun-baked terracotta':'#B07458','warm peach':'#E5A485','coral pink':'#E08A6F',
    'muted coral':'#D08C72','deep red':'#7A1F2B','hot pink':'#E5577D','magenta':'#A8327D',
    'pink':'#E59AB0','dusty pink':'#D0A0A0','dusty rose':'#C28C8C','pale lavender':'#C9C2D8',
    'sage':'#9BA889','sage green':'#9BA889','light sage':'#C2CDB4','muted olive':'#8A8A5C',
    'mint green':'#A5C7B0','coffee brown':'#5C4433','walnut brown':'#4D2F1E','walnut':'#4D2F1E',
    'original':'#6B3A3A','alternate':'#A8A29E',
    'black':'#1A1A1A','black frame':'#1A1A1A','dark wood':'#5C3F2A','dark wood frame':'#5C3F2A',
    'wood':'#B89972','wood frame':'#B89972','natural':'#B89972','natural wood':'#B89972',
    'white':'#F0EBE3','white frame':'#F0EBE3','oak':'#C9A877','ash':'#D6C3A0'
  };

  function initEditionPreview(root) {
    var ed = root.querySelector('[data-lc-edition]');
    if (!ed) return;
    var preview = ed.querySelector('[data-lc-edition-preview]');
    if (!preview) return;
    var pimg = preview.querySelector('[data-lc-edition-preview-img]');
    // v66 — swatch rows live in a host ABOVE the image (under the format bar).
    var swatchHost = preview.querySelector('[data-lc-edition-swatch-host]') || preview;

    var siblings = {};
    var sibScript = document.querySelector('[data-lc-sibling-urls]');
    if (sibScript) { try { siblings = JSON.parse(sibScript.textContent); } catch (e) {} }

    var SIZE_RE = /^(size|sizes|boyut|ölçü|olcu)$/i;

    // v98 — Preload EVERY format + variant preview image so switching the
    // Canvas/Metal/Wooden/Framed segments (and colour/frame swatches) is instant —
    // no fresh network fetch on click (Mert: "gecikmeler kesinlikle olmamali").
    // Cache the exact URLs setImg() will assign + decode them off the main thread.
    var lcEditionPreloadCache = {};
    function lcPreloadEditionImages() {
      var urls = [];
      Object.keys(siblings || {}).forEach(function (fmt) {
        var data = siblings[fmt];
        if (!data) return;
        if (data.image) urls.push(data.image);
        (data.variants || []).forEach(function (v) { if (v && v.image) urls.push(v.image); });
      });
      urls.forEach(function (u) {
        if (!u || lcEditionPreloadCache[u]) return;
        var im = new Image();
        try { im.decoding = 'async'; } catch (e) {}
        im.src = u;
        lcEditionPreloadCache[u] = im;
      });
    }
    // v99 — EAGER preload: start downloading every format/variant image the moment
    // the preview inits (no idle wait). Previously double-deferred (boot idle 1.5s +
    // preload idle 2.5s ≈ up to 4s), so an early click hit a cold cache → visible lag.
    lcPreloadEditionImages();

    function setImg(src) {
      if (!src || !pimg) return;
      pimg.removeAttribute('srcset');
      // v99 — decode the (already preloaded) image off the main thread, then swap in
      // one tick so the change is instant with no decode flash. Fall back to a plain
      // src set if decode() is unavailable or the image is not yet cached.
      var pre = lcEditionPreloadCache[src];
      if (pre && pre.decode) {
        pre.decode().then(function () { pimg.src = src; }).catch(function () { pimg.src = src; });
      } else {
        pimg.src = src;
      }
    }

    var FRAME_RE = /(frame|finish|çerçeve)/i;

    // v68 — Frame-finish label: Title-Case, "Frame" word dropped per Mert.
    //   "white frame" → "White", "Dark Wood Frame" → "Dark Wood"
    function frameLabel(val) {
      var s = String(val || '').replace(/\s*frame\s*$/i, '').trim();
      s = s.replace(/\w\S*/g, function (w) { return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase(); });
      return s;
    }

    // Build the swatch row(s) for a given format from the sibling data.
    // v62 — Colour options render as colour dots; Frame/finish options render as
    // text-label pills (never coloured dots). No catalog value falls to grey.
    function renderSwatches(fmt) {
      swatchHost.querySelectorAll('[data-lc-edition-preview-swatches]').forEach(function (n) { n.remove(); });
      var data = siblings && siblings[fmt];
      if (!data || !data.options) return;
      data.options.forEach(function (opt) {
        if (!opt || SIZE_RE.test(opt.name || '') || !opt.values || opt.values.length < 2) return;
        var isFrame = FRAME_RE.test(opt.name || '');
        var row = document.createElement('div');
        row.className = 'lc-pdp__edition-preview-swatches' + (isFrame ? ' lc-pdp__edition-preview-swatches--frame' : '');
        row.setAttribute('data-lc-edition-preview-swatches', '');
        row.setAttribute('role', 'group');
        row.setAttribute('aria-label', opt.name || 'Variant');
        opt.values.forEach(function (val, vi) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.setAttribute('data-lc-edition-swatch', val);
          btn.title = val;
          if (isFrame) {
            // Frame finish → text-label pill
            btn.className = 'lc-pdp__edition-preview-swatch lc-pdp__edition-preview-swatch--label' + (vi === 0 ? ' is-active' : '');
            btn.setAttribute('aria-label', frameLabel(val));
            btn.innerHTML = '<span class="lc-pdp__edition-preview-swatch-text">' + frameLabel(val) + '</span>';
          } else {
            // Colour → colour dot
            var hex = LC_EDITION_HEX[(val || '').toLowerCase().trim()] || '#C9C5BF';
            btn.className = 'lc-pdp__edition-preview-swatch' + (vi === 0 ? ' is-active' : '');
            btn.setAttribute('aria-label', val);
            btn.innerHTML = '<span class="lc-pdp__edition-preview-swatch-dot" style="background:' + hex + '"></span>';
          }
          btn.addEventListener('click', function () {
            var v = (data.variants || []).filter(function (vr) {
              return [vr.option1, vr.option2, vr.option3][opt.position - 1] === val;
            })[0];
            setImg((v && v.image) || data.image);
            row.querySelectorAll('[data-lc-edition-swatch]').forEach(function (s) {
              s.classList.toggle('is-active', s === btn);
            });
          });
          row.appendChild(btn);
        });
        swatchHost.appendChild(row);
      });
    }

    // Switch the preview to a format: image → that format's featured, swatches rebuilt.
    function showFormat(fmt) {
      var data = siblings && siblings[fmt];
      if (data && data.image) setImg(data.image);
      renderSwatches(fmt);
    }

    // Initial render for the format the page's product currently is.
    var startFmt = ed.getAttribute('data-active-fmt') || 'canvas';
    renderSwatches(startFmt);

    // Expose so the format selector can drive it.
    root.__lcEditionShowFormat = showFormat;
  }

  // v38/v60 — Editorial format segmented selector: swap eyebrow + spec cards,
  // and drive the edition preview (image + swatches) to the chosen format.
  function initEditionFmtSelector(root) {
    var ed = root.querySelector('[data-lc-edition]');
    if (!ed) return;
    var matLabel = ed.querySelector('[data-lc-edition-mat-label]');
    var LABELS = { 'canvas': 'On the canvas', 'metal': 'On the metal', 'wood': 'On the wood', 'framed': 'In the frame' };
    ed.querySelectorAll('[data-lc-edition-fmt]').forEach(function (seg) {
      seg.addEventListener('click', function () {
        var fmt = seg.getAttribute('data-lc-edition-fmt');
        if (!fmt || ed.getAttribute('data-active-fmt') === fmt) return;
        ed.setAttribute('data-active-fmt', fmt);
        if (matLabel && LABELS[fmt]) matLabel.textContent = LABELS[fmt];
        ed.querySelectorAll('[data-lc-edition-fmt]').forEach(function (s) {
          var isActive = s === seg;
          s.classList.toggle('is-active', isActive);
          s.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        if (root.__lcEditionShowFormat) root.__lcEditionShowFormat(fmt);
      });
    });
  }

  // R3 PERF — Two-phase boot. Critical handlers immediately (gallery, ATC,
  // edition fmt segs); heavy non-critical (format popup builder, edition
  // preview swatch renderer) deferred to idle so they don't block first paint
  // / first interaction. INP target <200 ms.
  function bootCritical() {
    document.querySelectorAll('[data-lc-pdp]').forEach(function (root) {
      init(root);
      parseDescription(root);
      // v99 — initEditionPreview promoted to critical boot. It wires the format/swatch
      // image-swap + starts the eager image preload. Previously deferred to idle (~1.5s),
      // so a format click in that window did nothing (handler not ready) and the first
      // swap hit a cold image cache. The swatch DOM it builds is tiny, so INP stays fine.
      initEditionPreview(root);
      initEditionFmtSelector(root);
      initRoomScene(root);
    });
    hidePdpPills();
    watchPdpPills();
  }
  // v100 — Notes-on-edition room scene: premium box + colorway picker + scroll-to-frames.
  function initRoomScene(root) {
    var ed = root.querySelector('[data-lc-edition][data-room-design]');
    if (!ed || !window.LACO_ROOMS) return;
    var design = ed.getAttribute('data-room-design');
    var isSig = ed.getAttribute('data-room-sig') === '1';
    var curfmt = ed.getAttribute('data-room-curfmt') || '';
    var entry = window.LACO_ROOMS[design];
    var img = ed.querySelector('[data-lc-room-img]');
    var skel = ed.querySelector('[data-lc-room-skel]');
    var noteEl = ed.querySelector('[data-lc-room-note]');
    var pick = ed.querySelector('[data-lc-room-pick]');
    var fig = ed.querySelector('[data-lc-room]');
    if (!entry || !img) { if (fig) fig.style.display = 'none'; return; }

    function show(url) {
      if (!url) return;
      var pre = new Image();
      pre.onload = function () { img.src = url; img.classList.add('is-on'); if (skel) skel.style.opacity = '0'; };
      pre.src = url;
    }
    var sceneFrame, url;
    if (isSig && entry.sig) {
      sceneFrame = 'Framed Canvas'; url = entry.sig.url; if (pick) pick.style.display = 'none';
    } else if (entry.colors) {
      sceneFrame = entry.frame;
      var sel = ed.getAttribute('data-room-color');
      if (!entry.colors[sel]) sel = Object.keys(entry.colors)[0];
      url = entry.colors[sel];
      if (pick) pick.querySelectorAll('[data-lc-room-dot]').forEach(function (d) {
        var c = d.getAttribute('data-lc-room-dot');
        if (!entry.colors[c]) { d.style.display = 'none'; return; }
        d.classList.toggle('is-active', c === sel);
        d.addEventListener('click', function () {
          if (!entry.colors[c]) return;
          pick.querySelectorAll('[data-lc-room-dot]').forEach(function (x) { x.classList.remove('is-active'); });
          d.classList.add('is-active');
          show(entry.colors[c]);
        });
      });
    } else if (entry.single) {
      sceneFrame = entry.frame; url = entry.single; if (pick) pick.style.display = 'none';
    } else if (entry.sig) {
      sceneFrame = 'Framed Canvas'; url = entry.sig.url; if (pick) pick.style.display = 'none';
    } else { if (fig) fig.style.display = 'none'; return; }
    show(url);
    if (noteEl) {
      noteEl.innerHTML = '<span class="lc-room__note-l1">You’re viewing the <b>' + (curfmt || sceneFrame || 'Metal Framed') + '</b> edition.</span><span class="lc-room__note-l2">Scroll down to see this piece in every available frame.</span>';
    }
    var sc = ed.querySelector('[data-lc-room-scroll]');
    if (sc) sc.addEventListener('click', function () {
      var fq = document.querySelector('[data-lc-fq]');
      if (fq) fq.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function bootDeferred() {
    document.querySelectorAll('[data-lc-pdp]').forEach(function (root) {
      initFormatPopup(root);
      initRoomCart(root);
    });
  }
  function boot() {
    bootCritical();
    if (window.requestIdleCallback) {
      requestIdleCallback(bootDeferred, { timeout: 1500 });
    } else {
      setTimeout(bootDeferred, 100);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* v114 — Format takasindan sonra yeniden baglanma.
     `init()` zaten `root._lcInit` ile korunuyor, yani boot'u tekrar cagirmak ESKI
     dugumlere ikinci kez el atmaz; yalnizca takasla gelen YENI dugumu kurar.
     Bu yuzden guvenli ve ayrica idempotent. */
  window.LCPDP = window.LCPDP || {};
  window.LCPDP.boot = boot;
  document.addEventListener('lc:pdp:swapped', boot);
})();

